import React, { useState } from "react";
import "./index.scss";
import { Link } from "react-router-dom";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import axios from "axios";

const ForgotPassword = () => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const [phoneNumber, setPhoneNumber] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [isCodeStep, setIsCodeStep] = useState(false);
  const [isPasswordStep, setIsPasswordStep] = useState(false);

  const handleSubmitPhone = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccessMessage(null);

    const cleanedNumber = phoneNumber.replace(/\s+/g, "").replace("+", "");

    if (!cleanedNumber.startsWith("996") || cleanedNumber.length < 12) {
      return setError(
        "Введите корректный номер телефона (например: +996700707070)"
      );
    }

    try {
      setLoading(true);
      await axios.post(`${API_URL}/owners/send-verification-code`, {
        phoneNumber: cleanedNumber,
      });
      setSuccessMessage("Код подтверждения отправлен");
      setIsCodeStep(true);
    } catch (err) {
      setError(err.response?.data?.message || "Произошла ошибка");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitCode = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccessMessage(null);

    try {
      setLoading(true);
      await axios.post(`${API_URL}/owners/verification-code`, {
        phoneNumber: phoneNumber.replace(/\s+/g, "").replace("+", ""),
        code: verificationCode,
      });
      setSuccessMessage("Код подтверждён, можно сменить пароль");
      setIsPasswordStep(true);
      setIsCodeStep(false);
    } catch (err) {
      setError(err.response?.data?.message || "Неверный код");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitPassword = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccessMessage(null);

    try {
      setLoading(true);
      await axios.post(`${API_URL}/owners/reset-password`, {
        phoneNumber: phoneNumber.replace(/\s+/g, "").replace("+", ""),
        code: verificationCode,
        newPassword,
      });
      setSuccessMessage("Пароль успешно изменён");
      window.location("/login")
    } catch (err) {
      setError(err.response?.data?.message || "Не удалось изменить пароль");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgotPassword">
      <div className="forgotPassword__form">
        <Link className="forgotPassword__login" to="/login">
          <MdOutlineKeyboardArrowLeft className="forgotPassword__icon" />
          Назад
        </Link>
        <h2 className="forgotPassword__title">Восстановить пароль</h2>

        <form
          onSubmit={
            isPasswordStep
              ? handleSubmitPassword
              : isCodeStep
              ? handleSubmitCode
              : handleSubmitPhone
          }
        >
          <div className="form-group">
            {error && <p className="form-group__error">{error}</p>}
            {successMessage && (
              <p className="form-group__success">{successMessage}</p>
            )}

            {isPasswordStep ? (
              ""
            ) : (
              <>
                <label className="form-group__label">Номер телефона</label>
                <input
                  type="tel"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  placeholder="+996700707070"
                  className="form-group__input"
                  disabled={isCodeStep || isPasswordStep}
                  required
                />
              </>
            )}

            {isCodeStep && (
              <>
                <label className="form-group__label">Код подтверждения</label>
                <input
                  type="text"
                  value={verificationCode}
                  onChange={(e) => setVerificationCode(e.target.value)}
                  placeholder="Введите код"
                  className="form-group__input"
                  required
                />
              </>
            )}

            {isPasswordStep && (
              <>
                <label className="form-group__label">Новый пароль</label>
                <input
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Введите новый пароль"
                  className="form-group__input"
                  required
                />
              </>
            )}
          </div>

          <button
            type="submit"
            className="form-group__button"
            disabled={loading}
          >
            {loading
              ? "Отправка..."
              : isPasswordStep
              ? "Сменить пароль"
              : isCodeStep
              ? "Подтвердить код"
              : "Отправить код подтверждения"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
